// global state for the multiple factories selection

import { atom } from "recoil";
export const multipleFactoriesState = atom({
    key: "multipleFactoriesState",
    default: [],
});
